import { ReactElement } from 'react';
import styles from './ui-menu-divider.module.scss';

export function UIMenuDivider(): ReactElement {
    return <div className={styles.container} />;
}
